export enum BuildEnv {
    Production = 'production',
    Development = 'development',
}

export const itemsOnPage = 15;
